import { SET_SOURCE_RATING } from "./actions";

export default {
  [SET_SOURCE_RATING](state, suppressedEmails) {
    state.sourceRating = suppressedEmails;
  },
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};
